import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CollaboratorSelector, { Collaborator } from '../CollaboratorSelector';
import Button from '../TailwindComponents/Button';

interface DraftAccessPanelProps {
  collaborators: Collaborator[];
  onChange: (collaborators: Collaborator[]) => void;
  selectorProps?: Record<string, any>;
  onClose: () => void;
}

/**
 * The access side panel for a record that does not exist yet.
 *
 * `manageResourceCollaborators` writes through to a saved resource (add,
 * remove, change access, connected teams by uuid); a create form has none of
 * that yet. This holds the list locally, hands every change straight back to
 * the form, and the form sends it with the create call - same panel slot,
 * same selector, so creating and managing access look and work alike.
 */
const DraftAccessPanel: React.FC<DraftAccessPanelProps> = ({
  collaborators,
  onChange,
  selectorProps,
  onClose,
}) => {
  const { t } = useTranslation();
  const [people, setPeople] = useState<Collaborator[]>(collaborators || []);

  const handleChange = (next: Collaborator[]) => {
    setPeople(next);
    onChange(next);
  };

  return (
    <div className="flex flex-col h-full min-h-0">
      <div className="flex-1 min-h-0 overflow-y-auto custom-scrollbar-main px-4 py-3">
        <CollaboratorSelector
          {...selectorProps}
          collaborators={people}
          onCollaboratorsChange={handleChange}
        />
      </div>
      <div className="flex justify-end gap-2 border-t border-hairline-soft px-4 py-3">
        <Button variant="primary" size="small" onClick={onClose}>
          {t('Done')}
        </Button>
      </div>
    </div>
  );
};

export default DraftAccessPanel;
